import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { MoreVertOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { Row } from "@tanstack/react-table"
import type { ReactNode } from "react"
import { useRef, useState } from "react"

import { type Contact } from "@/graphql/codegen/graphql"

export const CompanyContactActionsMenu = ({
  row,
  onViewClick,
}: {
  row: Row<Contact>
  onViewClick: (contact: Contact) => void
}): ReactNode => {
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const [open, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box
      className='flex items-center justify-center'
      onClick={(event) => {
        event.stopPropagation()
      }}
    >
      <IconButton onClick={handleOpen} ref={anchorElRef}>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => onViewClick(row.original)}>
          <ListItemIcon>
            <VisibilityOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='View Contact details' />
        </MenuItem>
      </Menu>
    </Box>
  )
}
